module.exports = __webpack_public_path__ + "img/ZS_logo.ce3ee37f.svg";